import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets the scroll position to the top whenever the meaningful route
 * changes. The language prefix is stripped so a /en → /ja toggle keeps your
 * position on the same page.
 * @returns {null}
 */
export function ScrollToTop() {
	const { pathname } = useLocation();
	const route = pathname.replace(/^\/(en|ja|ko|zh-cn|zh-tw)\b/, '');

	useEffect(() => {
		if (typeof window.scrollTo === 'function') { window.scrollTo(0, 0); }
	}, [route]);

	return null;
}
